<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body content-body" [hidden]="minimise">
  <!-- Loader -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- Form Content -->
  @if (!showFormLoader) {
<div>
    <div class="panel panel-default" style="margin-top: 12px;">
      <div class="panel-body">
        <!-- Template ID Row -->
        <div class="form-row">
          <div class="col-md-6">
            <label>Template ID:</label>
          </div>
          <div class="col-md-6">
            <ap-dropdown class="field-full-width" [list]="templateDropdownItems" [selectType]="'single'"
              [title]="'Template ID'" [hideTitleOnInput]="true" [inputAriaLabel]="'Template ID'"
              [(ngModel)]="selectedTemplateItem" (onSelect)="onTemplateSelect($event)">
              @for (item of templateDropdownItems; track $index) {
                <ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setDropdownAriaLabel(item, 'Template ID')"
                  (onSelectItem)="onTemplateSelectItem($event)"></ap-dropdown-list-item>
              }
            </ap-dropdown>
          </div>
        </div>

        <br />

        <!-- Is Excluded Row -->
        <div class="form-row">
          <div class="col-md-6">
            <label>Is Excluded:</label>
          </div>
          <div class="col-md-6">
            <ap-checkbox
              [(ngModel)]="isExcluded"
              [ngModelOptions]="{standalone: true}"
              [inputId]="'isExcluded'"
              [ariaLabel]="'Is Excluded'">
            </ap-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button 
    class="save-button" 
    type="button" 
    [disabled]="isSaveClicked || !isFormValid()"
    (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save
  </button>
  <button 
    class="cancel-button" 
    type="button" 
    (click)="cancel()">
    Cancel
  </button>
</div>
